import { prepareOrganizationTable } from '@/appLogic/initializers/organizationTable';
import { preparePreferenceTable } from '@/appLogic/initializers/preferenceTable';
import { setAwsResources, setLogoutFunc } from '@/appLogic/leanpath/wrappers';
import { awsResources } from '@/awsCodes/resourceParams';
import { normalLogout } from '@/awsCodes/awsLogout';
import { prepareSharingTable } from '@/appLogic/initializers/sharingTable';
setAwsResources(awsResources, '');
setLogoutFunc(normalLogout);

let initializedFlag = false;

/**
 *
 */
const isInitialized = () => initializedFlag;

const connectServer = false; // サーバに接続せずローカルのみで実験するときはfalseにしておく

/**
 *
 */
const initProcess = async () => {
  // TODO: 並列で
  await prepareOrganizationTable(connectServer);
  await prepareSharingTable(connectServer);
  await preparePreferenceTable(connectServer);
  initializedFlag = true; // 初期化が完了したらtrueをセットしてください。他の初期化処理があればこの行の前に書いてください。
};

export { initProcess, isInitialized };
